/**
 * @generated SignedSource<<580e95e7f75dc94426e3f3f54879f115>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditBookingModal_Booking$data = {
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly club: {
          readonly supportsPrivate: boolean;
        } | null | undefined;
      };
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ModalStepOutlet_Booking" | "useInitializeEditBookingModal_Booking">;
  readonly " $fragmentType": "EditBookingModal_Booking";
};
export type EditBookingModal_Booking$key = {
  readonly " $data"?: EditBookingModal_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditBookingModal_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditBookingModal_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useInitializeEditBookingModal_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ModalStepOutlet_Booking"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "cbe137aa6764548ff275f78fa9f5b413";

export default node;
